<template>
  <div class="imageSlider" :style="{height: height + 'vh'}">
    <div class="slider-inner" :style="{height: height + 'vh'}">
      <div class="imageSlider-item" v-for="(image, key) in images" :key="key">
        <transition :name="transitionName">
          <img :src="image" class="d-block" :alt="image" v-if="key === slider">
        </transition>
      </div>
    </div>
    <div class="carousel-control-prev cursor" @click="previous">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </div>
    <div class="carousel-control-next cursor" @click="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    height: Number,
    images: Array
  },
  data () {
    return {
      slider: 0,
      transitionName: 'fade'
    }
  },
  // mounted () {
  //   setTimeout(() => this.next(), 8000)
  // },
  methods: {
    next () {
      this.transitionName = 'fade'
      if (this.slider === this.images.length - 1) {
        this.slider = 0
      } else {
        this.slider = this.slider + 1
      }
    },
    previous () {
      this.transitionName = 'fade'
      if (this.slider === 0) {
        this.slider = this.images.length - 1
      } else {
        this.slider = this.slider - 1
      }
    }
  }
}
</script>

<style scoped>
  .carousel-control-prev {
    z-index: 9999;
  }
  .imageSlider-item {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .imageSlider-item img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .fade-enter-active, .fade-leave-active {
     transition: all 0.9s ease;
     overflow: hidden;
     visibility: visible;
     position: absolute;
     width:100%;
     opacity: 1;
}
 .fade-enter, .fade-leave-to {
     visibility: hidden;
     width:100%;
     opacity: 0;
}
  .slideFromRight-enter-active {
    transition: all 0.5s ease;
  }
  .slideFromRight-leave-active {
    transition: all 0.5s ease;
  }
  .slideFromRight-enter-from {
    transform: translateX(100%);
    opacity: 1;
  }
  .slideFromRight-leave-to {
    transform: translateX(-100%);
    opacity: 1;
  }

  .slideFromLeft-enter-active {
    transition: all 0.5s ease;
  }
  .slideFromLeft-leave-active {
    transition: all 0.5s ease;
  }
  .slideFromLeft-enter-from {
    transform: translateX(-100%);
    opacity: 1;
  }
  .slideFromLeft-leave-to {
    transform: translateX(100%);
    opacity: 1;
  }
</style>
